<template>
  <div>
    <el-drawer :visible.sync="userDrawer" direction="ltr" size="70%" :before-close="handleClose">
      <div class="drawer-cont">
        <div class="userinfo-msg" @click="$router.push('/my/center')" style="width:90%;overflow:hidden;">
          <div class="avatar">
            <img src="../../../assets/logo.png" alt="">
          </div>
          <div class="text">
            <div class="name">
              {{ userInfo.username }}
            </div>
            <div class="uid">
              {{$t('addnew.score')}}: {{ userInfo.creditScore }}
            </div>
            <div class="uid">
              UID: {{userInfo.id}}
            </div>
            <div class="uid">
              {{$t('assets.userinfo_nav1')}}: {{userInfo.realState === 1 ? $t("account.verifySuccess") : $t("account.verifyFailed") }}
            </div>
            <div class="uid" v-if="userInfo.levelNumber > 0" style="font-weight:bold">
              <span v-if="userInfo.levelNumber === 1" style="color:red">V I P： VIP {{ userInfo.levelNumber }}</span>
              <span v-if="userInfo.levelNumber === 2" style="color:orange">V I P： VIP {{ userInfo.levelNumber }}</span>
              <span v-if="userInfo.levelNumber === 3" style="color:yellow">V I P： VIP {{ userInfo.levelNumber }}</span>
              <span v-if="userInfo.levelNumber === 4" style="color:green">V I P： VVIP 1</span>
              <span v-if="userInfo.levelNumber === 5" style="color:blue">V I P： VVIP 2</span>
              <span v-if="userInfo.levelNumber === 6" style="color:purple">V I P： VVIP 3</span>
            </div>
          </div>
        </div>
        <div class="userinfo-list">
          <div class="item" @click="$router.push('/my/identity')">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list1.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav1')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="item" @click="$router.push('/my/share')">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list2.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav2')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
<!--          <div class="item" @click="$router.push('/my/empower')">-->
<!--            <div class="left">-->
<!--              <div class="icon">-->
<!--                <img src="../../../../static/image/my-list3.png" alt="">-->
<!--              </div>-->
<!--              <div class="text">{{$t('assets.userinfo_nav3')}}</div>-->
<!--            </div>-->
<!--            <div class="more">-->
<!--              <i class="el-icon-arrow-right"></i>-->
<!--            </div>-->
<!--          </div>-->
          <div class="item" @click="$router.push('/my/security')">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list4.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav4')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
<!--          <div class="item" @click="$router.push('/my/collect')">-->
<!--            <div class="left">-->
<!--              <div class="icon">-->
<!--                <img src="../../../../static/image/my-list5.png" alt="">-->
<!--              </div>-->
<!--              <div class="text">{{$t('assets.userinfo_nav5')}}</div>-->
<!--            </div>-->
<!--            <div class="more">-->
<!--              <i class="el-icon-arrow-right"></i>-->
<!--            </div>-->
<!--          </div>-->
          <div class="item" @click="jumpUrl()">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list6.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav6')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="item" @click="$router.push('/my/about')">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list7.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav7')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
<!--          <div class="item" @click="jumpUrl2()">-->
<!--            <div class="left">-->
<!--              <div class="icon">-->
<!--                <img src="../../../../static/image/my-list8.png" alt="">-->
<!--              </div>-->
<!--              <div class="text">{{$t('assets.userinfo_nav8')}}</div>-->
<!--            </div>-->
<!--            <div class="more">-->
<!--              <i class="el-icon-arrow-right"></i>-->
<!--            </div>-->
<!--          </div>-->
          <div class="item" @click="$router.push('/my/help')">
            <div class="left">
              <div class="icon">
                <img src="../../../../static/image/my-list9.png" alt="">
              </div>
              <div class="text">{{$t('assets.userinfo_nav9')}}</div>
            </div>
            <div class="more">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="btn">
          <el-button @click="logout()">{{$t('assets.logout')}}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getItemList,serviceUrl } from "@/api/global"
import {getInfo} from "@/api/login"
import { getToken } from "@/utils/auth";
export default {
  props: {
    userDrawer: Boolean,
  },
  data() {
    return {
      loginState: false,
      typeList: [],
      userInfo: {},
      downloadUrl: "https://www.alcg.store/ALCG.apk"
    };
  },
  computed: {

  },
  created() {
    let token = getToken()
    if (token) {
      this.loginState = true
    }
    this.getList()
  },
  methods: {
    getList() {
      getItemList({ typeId: 4, page: 0, size: 50 }).then(response => {
        this.typeList = response.Data.content
      });
      if(this.loginState){
        getInfo().then(response => {
          this.userInfo = response.Data
        });
      }
    },
    stateChange() {
      this.$emit("userinfoClose")
    },
    handleClose() {
      this.stateChange()
    },
    jumpUrl() {
      window.open(serviceUrl)
    },
    jumpUrl2(){
      window.open("https://www.alcg.store/ALCG.apk")
    },
    async logout() {
        await this.$confirm(this.$t('my.my.logout'), this.$t('common.notice'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.close'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/logout')
          this.$router.push(`/login`)
        })
      },
  },
  destroyed: function () {

  }
}
</script>

<style lang="less">
.el-drawer__header {
  display: none;
}

.drawer-cont {

}

.userinfo-msg {
  display: flex;
  align-items: center;
  padding: 40px 20px;
  border-bottom: 1px solid #ebebeb;
  .avatar {
    font-size: 0;

    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
  }

  .text {
    padding-left: 22px;

    .name {
      font-size: 32px;
    }

    .uid {
      font-size: 24px;
    }
  }
}

.userinfo-list {
  .item {
    padding: 30px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ebebeb;

    .left {
      display: flex;
      align-items: center;
      .icon {
        font-size: 0;
        img {
          width: 40px;
          height: 40px;

        }
      }

      .text {
        margin-left: 20px;
        font-size: 24px;
      }
    }
  }
}

.btn {
  padding: 40px 20px;
  .el-button {
    background: #f66;
  }
}
</style>
